<template>
    <v-dialog v-model="$store.state.newTransact.NotPost" persistent min-width="1360px" transition="dialog-transition">
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">
                    Not Post
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="white" dark icon
                    @click="$store.state.newTransact.NotPost = false;"><v-icon>mdi-close-circle</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table :headers="headersNotPost" v-if="!daily" :items="orders"  dense :search="search"
                    class="elevation-1"  pagination.sync="pagination">
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="search" label="Search" class="mb-1" dense
                                    style="margin-top: 0px;padding: 10px;" hide-details></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-btn color="primary" small class="mt-4 ml-10" @click="downloadExcelNoPost">Export
                                    <v-icon>mdi-microsoft-excel</v-icon></v-btn>
                                    <v-checkbox label="Daily Summary" v-model="daily" class="float-left"></v-checkbox>
                            </v-col>
                            <v-col cols="1">

                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
                <v-data-table :headers="headersDaily" v-else :items="shifts"  dense :search="search"
                    class="elevation-1"  pagination.sync="pagination">
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="search" label="Search" class="mb-1" dense
                                    style="margin-top: 0px;padding: 10px;" hide-details></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-btn color="primary" small class="mt-4 ml-10" @click="downloadExcelNoPost">Export
                                    <v-icon>mdi-microsoft-excel</v-icon></v-btn>
                                    <v-checkbox label="Daily Summary" v-model="daily" class="float-left"></v-checkbox>
                            </v-col>
                            <v-col cols="1">

                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from "axios";
export default {
    props: ['orders'],
    data: function () {
        return {
            shifts:[],
            search: '',
            daily:false,
            headersNotPost: [
                { text: 'Customer', value: 'Customer' },
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'OrderStatus', value: 'OrderStatus' },
                { text: 'OrderID', value: 'OrderID' },
                { text: 'BillOfLading', value: 'BillOfLading' },
                { text: 'Product', value: 'Product' },
                { text: 'TempAdjQuantity', value: 'TempAdjQuantity' },
                { text: 'InvRate', value: 'InvRate' },
                { text: 'InvGasRate', value: 'InvGasRate' },
                { text: 'Actions', value: 'Actions' },
            ],
            headersDaily: [
                { text: 'ShiftDetail', value: 'ShiftDetail'},
                { text: 'Driver', value: 'Driver' },
                { text: 'Truck', value: 'Truck' },
                { text: 'Trailer', value: 'Trailer' },
                { text: 'Actions', value: 'Actions' },
            ],
        }
    },
    mounted() {
        this.getOrdertoTransactNotPost();
    },
    methods: {
        downloadExcelNoPost: function () {
            var str = this.$store;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                // Customer: this.customer.id,
                Export: 1,
                
                Daily: this.daily,
            };
            str.state.isLoading = true;
            axios
                .post('new-transaction/not-post', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        'No post Report Revenue.xlsx'
                    );
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        getOrdertoTransactNotPost: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Daily: true,
            };
            axios
                .post('new-transaction/not-post', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.shifts = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
    }
}
</script>